import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { gql } from 'apollo-angular';

import { BitfGraphQlService } from '@bitf/services/graph-ql/bitf-graph-ql.service';

import { IBitfGraphQlRequest, IBitfGraphQlResponse } from '@interfaces';
import { AiPromptPreset } from '@models';
import { AI_PROMPT_PRESET_ENTITY } from './ai-prompt-preset.gql';
import { PAGINATION_ENTITY } from './strapi.gql';

@Injectable({
  providedIn: 'root',
})
// NOTE: Add methods following CRUD order
export class AiPromptPresetService extends BitfGraphQlService {
  constructor(public injector: Injector) {
    super(injector);
  }

  get(requestParams: IBitfGraphQlRequest = {}): Observable<IBitfGraphQlResponse<AiPromptPreset[]>> {
    requestParams.modelMapper = 'aiPromptPresets';
    requestParams.query = gql`
      ${AI_PROMPT_PRESET_ENTITY}
      ${PAGINATION_ENTITY}
      query Query($pagination: PaginationArg, $sort: [String], $filters: AiPromptPresetFiltersInput) {
        aiPromptPresets(pagination: $pagination, sort: $sort, filters: $filters) {
          data {
            ...AiPromptPresetEntity
          }
          meta {
            pagination {
              ...PaginationEntity
            }
          }
        }
      }
    `;

    return super.query<AiPromptPreset[]>(requestParams);
  }
}
